export default __webpack_public_path__ + "static/media/barclaycard.668963cd.png";